import "react-datepicker/dist/react-datepicker.css";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "./Amccn.css";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonButton from "../../../../Componants/Common/Button";
import {
  customerProduct,
  fetchAmcMaster,
  createCustomerAmc,
} from "../../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../../Componants/Loader/Loader";
import { Calendar } from "../../../../Componants/Common/Calender";
import { IconButton, Grid } from "@mui/material";

const calltype = [];

const CreateCustomerAmc = () => {
  const navigate = useNavigate();
  const [productData, setProductData] = useState(null);
  const [value, setValue] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amcDrop, setAmcDrop] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const calltypeDefaultProps = {
    options: calltype,
    getOptionLabel: (option) => option.title,
  };

  const [formData, setFormData] = useState({
    customerId: "",
    productId: "",
    amcId: "",
    amcStatus: "Running",
    startDate: null,
    endDate: null,
  });


  useEffect(() => {
    // Get the product data from localStorage
    const storedData = localStorage.getItem('amcProductData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setProductData(parsedData);

      // Store productId and customerId for API call
      if (parsedData.productId) {
        // Call the API with the productId
        fetchProductDetails(parsedData.productId);
      } else {
        // Clear form data if no product ID is present
        setFormData({
          customerId: "",
          productId: "",
          amcId: "",
          amcStatus: "Running",
          startDate: null,
          endDate: null,
          customerName: "",
          email: "",
          mobileNo: "",
          brand: "",
          productCategory: "",
          subCategory: "",
          model: "",
          serialNo: ""
        });
        toast.error('Product ID not found');
      }

      // Clear the data from localStorage after retrieving
      localStorage.removeItem('amcProductData');
    } else {
      // If no data is found, show error and redirect
      toast.error('No product data found');
      navigate(-1);
    }
  }, [navigate]);

  // Function to fetch product details using the API
  const fetchProductDetails = async (productId) => {
    // If no productId is provided, don't try to fetch details
    if (!productId) {
      // Clear form data
      setFormData({
        customerId: "",
        productId: "",
        amcId: "",
        amcStatus: "Running",
        startDate: null,
        endDate: null,
        customerName: "",
        email: "",
        mobileNo: "",
        brand: "",
        productCategory: "",
        subCategory: "",
        model: "",
        serialNo: ""
      });
      return;
    }

    try {
      setLoading(true);
      const response = await customerProduct({
        productId: productId
      });

      if (response.status === "success" && response.data.products?.length > 0) {
        const product = response.data.products[0];
        console.log("tushar : ", product);
        
        // Set form data with API response
        setFormData((prevData) => ({
          ...prevData,
          customerId: product.customerId || "",
          productId: product._id || "",
          customerName: product.customerName || "",
          email: product.customerEmail || "",
          mobileNo: product.customerMobile || "",
          brand: product.brandName || "",
          productCategory: product.categoryName || "",
          subCategory: product.subcategoryName || "",
          model: product.modelName || "",
          serialNo: product.serialNo || "",
          amcStatus: product.amcStatus || "Running",
        }));
      } else {
        toast.error("Failed to fetch product details");
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      toast.error("An error occurred while fetching product details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAMCList();
  }, []);

  const fetchAMCList = async () => {
    setLoading(true);
    try {
      const response = await fetchAmcMaster();
      if (response.status === "success") {
        setAmcDrop(response.data.amcs);
        setTotalRecords(response.data.totalAmcs);
      } else {
        toast.error(response.message || "Failed to fetch data.");
        setAmcDrop([]);
        setTotalRecords(0);
      }
    } catch (error) {
      toast.error("Error fetching customer details.");
      setAmcDrop([]);
      setTotalRecords(0);
      console.error("Error in fetchCustomerDetails:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (fieldName, date, formattedDate) => {
    if (!formData.amcId) {
      toast.error("Please select an AMC first.");
      return;
    }

    if (fieldName === "startDate") {
      // Update the startDate in the state
      setFormData((prev) => ({
        ...prev,
        startDate: date
      }));

      // Find the selected AMC's duration
      const selectedAmc = amcDrop.find((amc) => amc._id === formData.amcId);

      if (selectedAmc && selectedAmc.duration) {
        try {
          // Extract the duration value (assuming it represents months)
          let durationMonths;
          if (typeof selectedAmc.duration === 'string') {
            const match = selectedAmc.duration.match(/\d+/);
            durationMonths = match ? parseInt(match[0], 10) : 1;
          } else if (typeof selectedAmc.duration === 'number') {
            durationMonths = selectedAmc.duration;
          } else {
            durationMonths = 1;
          }

          // Calculate the endDate
          const baseDate = date.$d ? new Date(date.$d) : new Date(date);
          const calculatedEndDate = new Date(baseDate);
          calculatedEndDate.setMonth(calculatedEndDate.getMonth() + durationMonths);

          // Update the endDate in the state
          setFormData((prev) => ({
            ...prev,
            endDate: calculatedEndDate
          }));
        } catch (error) {
          console.error('Error calculating end date:', error);
          toast.error('Error calculating end date. Please try again.');
        }
      }
    }
        if (fieldName === "endDate") {
      // Update the startDate in the state
      setFormData((prev) => ({
        ...prev,
        endDate: date
      }));
    }
  };

  const handleAmcSelect = (event, value) => {
    if (value) {
      setFormData((prev) => ({
        ...prev,
        amcId: value._id,
        endDate: "", // Clear end date if AMC changes
        startDate: "", // Clear start date if AMC changes
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        amcId: "",
        endDate: null, 
        startDate: null, 
      }));
    }
  };

  const handleCreateAmc = async () => {
    const { startDate, amcId, customerId, productId } = formData;

    if (!startDate) {
      toast.error("Please select a start date.");
      return;
    }

    if (!customerId || !productId) {
      toast.error("Customer and product information is required.");
      return;
    }

    setLoading(true);

    try {
      // Format dates for API
      const formatDateForAPI = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      };

      // Prepare Payload with formatted dates
      const payload = {
        customerId,
        productId,
        amcId,
        amcStatus: "Running",
        startDate: formatDateForAPI(startDate),
        endDate: formatDateForAPI(formData.endDate)
      };

      // Call Create AMC API
      const createAmcResponse = await createCustomerAmc(payload);
      if (createAmcResponse.status === "success") {
        toast.success(createAmcResponse.message || "AMC assigned successfully!");
        console.log("Response Data:", createAmcResponse.data);
      } else {
        // Display the specific error message from the API response
        toast.error(createAmcResponse.message || "Failed to assign AMC.");

        // If it's the "already assigned" error, we could provide additional guidance
        if (createAmcResponse.message === "AMC already assigned to this product") {
          console.log("This product already has an AMC assigned to it");
          // You could add additional UI feedback here if needed
        }
      }
    } catch (error) {
      console.error("Error creating AMC:", error);

      // Check if the error response has the specific error format
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        if (errorData.status === "error" && errorData.message) {
          toast.error(errorData.message);
          return;
        }
      }

      // Default error message if we can't extract a specific message
      toast.error("An error occurred while creating AMC.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // Clear product ID and reset form data
    setProductData(null);
    setValue(null); // Reset AMC dropdown value
    setSelectedDate(null); // Reset date selection
    setFormData({
      // customerId: "",
      // productId: "",
      amcId: "", // Clear AMC ID
      // amcStatus: "Running", // Reset AMC status
      startDate: null,
      endDate: null,
      // customerName: "",
      // email: "",
      // mobileNo: "",
      // brand: "",
      // productCategory: "",
      // subCategory: "",
      // model: "",
      // serialNo: ""
    });
    // Navigate back
    // navigate(-1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <HeaderNavigation value={"Create Customer AMC"} />
      <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
        <IconButton
          onClick={handleCancel}
          sx={{
            backgroundColor: '#EFF3FE',
            color: '#33499F',
            border: '1px solid #33499F',
            borderRadius: '4px',
            padding: '4px',
            '&:hover': {
              backgroundColor: '#EFF3FE'
            }
          }}
        >
          <span style={{ fontSize: '16px' }}>✕</span>
        </IconButton>
      </div>
      <div className="Amccn-container">
        <div className="line-Amccn">
          <div className="textinput-Amccn">
            <TextField
              name="customerName"
              id="standard-basic"
              label="Customer Name"
              variant="standard"
              value={formData.customerName}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="textinput-Amccn">
            <TextField
              name="email"
              id="standard-basic"
              label="Email"
              variant="standard"
              value={formData.email}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="textinput-Amccn">
            <TextField
              name="mobileNo"
              id="standard-basic"
              label="Mobile No"
              variant="standard"
              value={formData.mobileNo}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="textinput-Amccn"></div>
        </div>
        <div className="line-Amccn">
          <div className="textinput-Amccn">
            <TextField
              name="brand"
              id="standard-basic"
              label="Brand"
              variant="standard"
              value={formData.brand}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="textinput-Amccn">
            <TextField
              name="productCategory"
              id="standard-basic"
              label="Product Category"
              variant="standard"
              value={formData.productCategory}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="textinput-Amccn">
            <TextField
              name="subCategory"
              id="standard-basic"
              label="Sub Category"
              variant="standard"
              value={formData.subCategory}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="textinput-Amccn">
            <TextField
              name="model"
              id="standard-basic"
              label="Model"
              variant="standard"
              value={formData.model}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </div>
        <div className="line-Amccn">
          <div className="textinput-Amccn">
            <TextField
              name="serialNo"
              id="standard-basic"
              label="Serial No"
              variant="standard"
              value={formData.serialNo}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="textinput-Amccn">
            <TextField
              name="amcStatus"
              id="standard-basic"
              label="AMC Status"
              variant="standard"
              value={formData.amcStatus}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          <div className="textinput-Amccn">
            {/* <TextField
              className="date-Amccn"
              label="Valid Till"
              type="date"
              value={formData.endDate} // Bind to `formData.endDate`
              InputProps={{ readOnly: true }} // Make it read-only
              InputLabelProps={{
                shrink: true
              }}
            /> */}
          </div>
          <div className="textinput-Amccn"></div>
        </div>

        <div className="line-Amccn">
          <div className="textinput-Customerservice">
            <Autocomplete
              {...calltypeDefaultProps}
              // id="disable-close-on-select"
              // disableCloseOnSelect
              options={amcDrop}
              value={amcDrop.find((amc) => amc._id === formData.amcId) || null}
              getOptionLabel={(option) => option.name}
              onChange={handleAmcSelect}
              isOptionEqualToValue={(option, value) =>
                option._id === value?._id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="
                    Select AMC"
                  variant="standard"
                />
              )}
            />
          </div>
          <div className="textinput-Amccn">
            <Calendar
              value={formData.startDate}
              handleChange={handleDateChange}
              fieldName="startDate"
              label="Start Date"
              withPortal={true}
              maxDate={formData.endDate}
            />
          </div>
          <div className="textinput-Amccn">
            <Calendar
              value={formData.endDate}
              handleChange={handleDateChange}
              minDate={formData.startDate}
              fieldName="endDate"
              label="End Date"
              readOnly={true}
              disabled={true}
            />
          </div>

          <div className="textinput-Amccn"></div>
        </div>
        <Grid container gap={5} sx={{ marginTop: "1rem", paddingLeft: "10px" }}>
          <Grid item>
            <CommonButton name={"Create"} handleOnClick={handleCreateAmc} />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
          </Grid>
        </Grid>
      </div>
      <Toaster />
      {loading && <Loader />}
    </>
  );
};

export default CreateCustomerAmc;
